// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3 {
  margin-top: 25px;
  margin-bottom: 13px;
  padding: 0;
}

div.col-md-6 {
  padding-left: 0;
}

input[type=text] {
  border: 0;
  padding: inherit;
  width: 100%;
}

select {
  background-color: white;
  width: 100%;
  border: 0;
  border-radius: 0;
  padding: 0;
}

button[disabled] {
  opacity: 0.5;
}

.accntInfo table tr td label:not(.likeSpan) {
  font-size: 14px;
  margin-bottom: auto;
}

.accntInfo table tr td:nth-child(2) {
  padding-left: 5px;
}

.accntInfo table tr td {
  padding-top: 12px;
}

.permCell {
  box-sizing: border-box;
  border-bottom: 1px solid #EDF2F5;
  padding-bottom: 2px;
}

tr.modifyButtons td {
  padding-top: 0 !important;
}

.modifyButtons td div.edit {
  text-align: right;
}

.modifyButtons div.edit div.saveText,
.modifyButtons div.edit div.cancelText {
  cursor: pointer;
}

.modifyButtons div.edit div.saveText {
  color: #007566;
}

tr.modifyButtons td.modifyEnabled:nth-child(2), tr.actionModify td.modifyEnabled {
  border-bottom: 2px solid #007566;
}

table.field {
  width: 95%;
}

table.field tr td {
  padding-top: 15px;
  font-family: Montserrat, sans-serif;
  padding-bottom: 4px !important;
}

table.field tr td:first-child {
  font-size: 14px;
  width: 35%;
}

table.field tr td {
  border-bottom: 1px solid #EDF2F5;
}

table.field tr td:nth-child(2) {
  padding-left: 5px;
}

table.field tr.actionModify td.pencilCell {
  width: 4%;
}

table.field tr.actionModify td.width50 {
  width: 50%;
}

table.field tr.actionModify td.rPadding5 {
  padding-right: 5px;
}

table.field tr.modifyButtons td {
  padding-top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/components/administration-account-form/administration-account-form.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,mBAAA;EACA,UAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,SAAA;EACA,gBAAA;EACA,WAAA;AACJ;;AAEA;EACI,uBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,eAAA;EACA,mBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,gCAAA;EACA,mBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;;EAEI,eAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AACA;EACI,iBAAA;EACA,mCAAA;EACA,8BAAA;AAEJ;;AACA;EACI,eAAA;EACA,UAAA;AAEJ;;AACA;EACI,gCAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AACA;EACI,SAAA;AAEJ;;AACA;EACI,UAAA;AAEJ;;AACA;EACI,kBAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ","sourcesContent":["h3 {\n    margin-top: 25px;\n    margin-bottom: 13px;\n    padding: 0;\n}\n\ndiv.col-md-6 {\n    padding-left: 0;\n}\n\ninput[type=text] {\n    border: 0;\n    padding: inherit;\n    width: 100%;\n}\n\nselect {\n    background-color: white;\n    width: 100%;\n    border: 0;\n    border-radius: 0;\n    padding: 0;\n}\n\nbutton[disabled] {\n    opacity: 0.5;\n}\n\n.accntInfo table tr td label:not(.likeSpan) {\n    font-size: 14px;\n    margin-bottom: auto;\n}\n\n.accntInfo table tr td:nth-child(2) {\n    padding-left: 5px;\n}\n\n.accntInfo table tr td {\n    padding-top: 12px;\n}\n\n.permCell {\n    box-sizing: border-box;\n    border-bottom: 1px solid #EDF2F5;\n    padding-bottom: 2px;\n}\n\ntr.modifyButtons td {\n    padding-top: 0 !important;\n}\n\n.modifyButtons td div.edit {\n    text-align: right;\n}\n\n.modifyButtons div.edit div.saveText,\n.modifyButtons div.edit div.cancelText {\n    cursor: pointer;\n}\n\n.modifyButtons div.edit div.saveText {\n    color: #007566;\n}\n\ntr.modifyButtons td.modifyEnabled:nth-child(2), tr.actionModify td.modifyEnabled {\n    border-bottom: 2px solid #007566;\n}\n\ntable.field {\n    width: 95%\n}\ntable.field tr td {\n    padding-top: 15px;\n    font-family: Montserrat,  sans-serif;\n    padding-bottom: 4px !important;\n}\n\ntable.field tr td:first-child {\n    font-size: 14px;\n    width: 35%;\n}\n\ntable.field tr td {\n    border-bottom: 1px solid #EDF2F5;\n}\n\ntable.field tr td:nth-child(2) {\n    padding-left: 5px;\n}\n\ntable.field tr.actionModify td.pencilCell {\n    width: 4%;\n}\n\ntable.field tr.actionModify td.width50 {\n    width: 50%;\n}\n\ntable.field tr.actionModify td.rPadding5 {\n    padding-right: 5px;\n}\n\ntable.field tr.modifyButtons td {\n    padding-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
